import { useEffect, useState } from 'react';
import { BASE_PATH } from './utils/basePath';

const useAuthCheck = () => {
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for logout=true in the URL. If present, set authenticated to false immediately.
    const urlParams = new URLSearchParams(window.location.search);
    const isLogout = urlParams.get('logout');
    
    if (isLogout === 'true') {
      setAuthenticated(false);
      setLoading(false);
      return;
    }
    
    // Don't trust URL parameters - always verify with backend
    const url = `${BASE_PATH}/api/check-auth`;
    
    fetch(url, {
      credentials: 'include'
    })
      .then(async res => {
        if (res.status === 200) {
          setAuthenticated(true);
        } else if (res.status === 401) {
          setAuthenticated(false);
        } else {
          setAuthenticated(false);
        }
        setLoading(false);
      })
      .catch(() => {
        setAuthenticated(false);
        setLoading(false);
      });
  }, []);

  return { authenticated, loading };
};

export default useAuthCheck; 